// extracted by mini-css-extract-plugin
module.exports = {"regular-horizontal":"columna_regular-horizontal__UDVh2","mb-500":"columna_mb-500___0Lok","centrat-horizontal":"columna_centrat-horizontal__yyxhn"};